import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { CommonDirectives } from '@app/shared/directives/common-directives';
import { UserAuthService } from '../../services/userAuth.service';
import { LoadSpinnerWrapperComponent } from "../../../../shared/components/load-spinner-wrapper/load-spinner-wrapper.component";
import { AppState } from '@app/core/store/app.state';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { Response } from '@app/core/interfaces/response';
import { ToastService } from '@app/core/services/toast.service';
import { PasswordResetStateService } from '../../services/password-reset-state.service';

@Component({
  selector: 'app-portal-login',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    CommonDirectives,
    RouterModule,
    LoadSpinnerWrapperComponent
],
  templateUrl: './portal-login-forgot-password.component.html',
  styleUrl: './portal-login-forgot-password.component.scss'
})
export class PortalLoginForgotPasswordComponent implements OnDestroy {
  ngDestroy$ = new Subject();
  loading: boolean = false;
  loginForm = this.fb.group({
    identifier: ['', Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private userAuthService: UserAuthService,
    private store: Store<AppState>,
    private router: Router,
    private toastService: ToastService,
    private passwordResetState: PasswordResetStateService
  ) {}

  ngOnDestroy(): void {
    this.ngDestroy$.next(true);
  }

  resetPassword() {
    const { identifier } = this.loginForm.value;
    if (identifier) {
      this.loading = true;
      this.userAuthService.forgotPassword(identifier)
        .subscribe({
          next: (_response: Response) => {
            this.loading = false;
            // Continue regardless of the response to avoid revealing whether an account exists.
            this.passwordResetState.save(identifier);
            this.router.navigate(['/reset-password'], { state: { identifier }});
          },
          error: () => {
            this.loading = false;
            this.toastService.showErrorToast('Unable to start password reset. Please try again.');
          }
        });
    }
  }
}
